import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import Pill from '@/components/molecules/pill/pill';
import styles from './configuration-flow-section.module.scss';

interface ConfigurationFlowSectionProps {
  /** Additional class names */
  className?: string;
  /** The index of the current step */
  currentStep: number;
  /** Indicates whether the step is active */
  isActive?: boolean;
  /** Indicates whether the step is completed */
  isCompleted?: boolean;
  /** The steps of the configuration flow */
  step: Content.Components['ConfigurationFlowModuleDto']['steps'][0];
}

const ConfigurationFlowSection = ({
  className,
  currentStep,
  isActive = false,
  isCompleted = false,
  step,
}: ConfigurationFlowSectionProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isActive]: isActive,
      })}
    >
      <div className={styles.topSection}>
        <Pill
          count={currentStep}
          icon={isCompleted ? 'CheckMark' : undefined}
          variant="secondary"
        />
      </div>

      <div className={styles.bottomSection}>
        <Typography className={styles.text} tagStyle="bodyMediumBold">
          {step.headline}
        </Typography>

        {step.description && (
          <Typography className={styles.description} tagStyle="bodySmall">
            {step.description}
          </Typography>
        )}
      </div>
    </div>
  );
};

ConfigurationFlowSection.displayName = 'ConfigurationFlowSection';

export default ConfigurationFlowSection;
